module.exports = {"title":"Бунтарь. Воин. Атеист","description":"Кем на самом деле был Василий Верещагин?","image":"https://vereshchagin.lenta.ru/img/facebook6.jpg","url":"https://vereshchagin.lenta.ru/","fbappid":396959934055666,"GTM":"GTM-K3DTRPR","top100":0,"clientTop100":0,"yaMetrika":0}


//////////////////
// WEBPACK FOOTER
// ./js/meta.json
// module id = 533
// module chunks = 0